import PageRecord from "models/view-models/page-record";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { SharedPageState } from "utilities/contexts/shared-page/shared-page-context";
import useQueryString from "utilities/hooks/routing/use-query-string";
import PageService from "utilities/services/notebooks/page-service";
import SharedPageService from "utilities/services/public/pages/shared-page-service";

interface SharedPublicPageQueryParams {
    recipient?: string;
}

const usePrintablePage = () => {
    const { pageId, pageGuid } = useParams<{
        pageId?: string;
        pageGuid?: string;
    }>();
    const [currentPage, setCurrentPage] = useState<PageRecord>();
    const [isLoading, setIsLoading] = useState(true);
    const [isErrored, setIsErrored] = useState(false);
    const { queryParams } = useQueryString<SharedPublicPageQueryParams>();
    const recipient = queryParams.recipient;

    const isPublicPage = useMemo(() => !!pageGuid, [pageGuid]);
    const [publicSharedState] = useState<SharedPageState>({
        pageGuid: pageGuid,
        recipientGuid: recipient,
    });
    const isPrintable = useMemo(() => {
        if (currentPage) {
            return true;
        }
    }, [currentPage]);
    useEffect(() => {
        const getPageById = async () => {
            setIsLoading(true);
            try {
                const response = isPublicPage
                    ? await SharedPageService.get(
                          { pageGuid: pageGuid! },
                          {
                              recipient: recipient,
                          }
                      )
                    : await PageService.get({ id: Number(pageId) });
                if (!response.resultObject) {
                    throw new Error();
                }
                setCurrentPage(response.resultObject);
            } catch (error) {
                setIsErrored(true);
            } finally {
                setIsLoading(false);
            }
        };

        getPageById();
    }, [isPublicPage, pageId, pageGuid, recipient]);

    return {
        currentPage,
        isLoading,
        isErrored,
        isPublicPage,
        publicSharedState,
        isPrintable,
    };
};

export default usePrintablePage;
